import axios from 'axios'
import KeycloakService from '../utils/keycloakService'
import {
  archivePatientRecord,
  bulkUpload,
  createNewPatient,
  deletePatientRecord,
  updateNewPatient,
} from '../utils/constants'
import { success } from '../features/patients/constants'

export const createPatient = async (payload: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${createNewPatient}`,
      payload,
      {
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          'Content-Type': 'application/json',
        },
      }
    )

    const { data, success, message } = response?.data ?? {}
    return {
      data,
      success: success !== false,
      message,
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const updatePatient = async (payload: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${updateNewPatient}`,
      payload,
      {
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          'Content-Type': 'application/json',
        },
      }
    )

    const { data, success, message } = response?.data ?? {}
    return {
      data,
      success: success !== false,
      message,
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const deletePatient = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_GATEWAY_URL}${deletePatientRecord}${data}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const ArchivePatient = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${archivePatientRecord}${data}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const BulkRegistration = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${bulkUpload}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    if (response?.data?.status === success) {
      const { data, message } = response?.data ?? {}
      return {
        data,
        success: true,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
